export enum NotificationApiPath {
  GET_NOTIFICATIONS = 'Notification/NotificationEvents',
  READ_NOTIFICATIONS = 'Notification/NotificationEvents/read',
  SUBSCRIBE_EMAIL = 'Notification/EmailNewsletters',
  CONTACT_US = 'Notification/ContactUs',
}
